import Swiper from 'swiper';
import { Pagination, Autoplay, A11y } from 'swiper/modules';

const LG_BREAKPOINT = 1024;

/**
 * HeroSlider — Alpine.js component for a responsive Swiper slider.
 *
 * - Below 1024px: horizontal slide direction
 * - 1024px and above: vertical slide direction (requires explicit height)
 *
 * InnerBlocks (HeroSliderCard) are rendered inside a .swiper-wrapper div,
 * but each card is wrapped by the block system's render.twig, so the
 * .swiper-slide class must be added via JS before Swiper initializes.
 * Swiper direction can't change dynamically, so it is destroyed and
 * reinitialized when crossing the breakpoint.
 */
window.HeroSlider = (sliderId) => {
	return {
		swiper: null,
		resizeObserver: null,

		init() {
			setTimeout(() => {
				const swiperEl = this.$el.querySelector('.' + sliderId);
				const wrapper = swiperEl.querySelector('.swiper-wrapper');
				if (!wrapper) return;

				const slides = wrapper.querySelectorAll(':scope > *');

				// Add .swiper-slide to each render wrapper since
				// the block system wraps each InnerBlock in a div
				slides.forEach(el => el.classList.add('swiper-slide'));

				// Build and initialize Swiper for the current viewport
				this.createSwiper(swiperEl, slides);

				// Re-initialize when crossing the lg breakpoint
				const mql = window.matchMedia(`(min-width: ${LG_BREAKPOINT}px)`);
				mql.addEventListener('change', () => {
					if (this.swiper) this.swiper.destroy(true, true);
					this.createSwiper(swiperEl, slides);
				});
			}, 0);
		},

		/**
		 * Creates a Swiper instance with direction based on viewport width.
		 * For vertical mode, measures the tallest slide and sets an explicit
		 * container height since Swiper requires it.
		 */
		createSwiper(swiperEl, slides) {
			const isVertical = window.innerWidth >= LG_BREAKPOINT;

			if (isVertical) {
				// Measure the tallest slide to set an explicit container
				// height — required for Swiper's vertical direction mode
				let maxHeight = 0;
				slides.forEach(el => {
					el.style.position = 'absolute';
					el.style.visibility = 'hidden';
					maxHeight = Math.max(maxHeight, el.scrollHeight);
				});
				slides.forEach(el => {
					el.style.position = '';
					el.style.visibility = '';
				});
				swiperEl.style.height = maxHeight + 'px';
			} else {
				swiperEl.style.height = '';
			}

			// Initialize Swiper
			this.swiper = new Swiper('.' + sliderId, {
				modules: [Pagination, Autoplay, A11y],
				slidesPerView: 1,
				direction: isVertical ? 'vertical' : 'horizontal',
				loop: true,
				autoplay: {
					delay: 7000,
					disableOnInteraction: false,
					pauseOnMouseEnter: false,
				},
				pagination: {
					el: '.' + sliderId + '-pagination',
					clickable: true,
				},
				a11y: {
					paginationBulletMessage: 'Go to slide {{index}}',
					containerRoleDescriptionMessage: 'Hero slider',
					itemRoleDescriptionMessage: 'Slide',
				},
			});
		},

	};
};
